import React from "react";
import { Route, Switch } from "react-router-dom";
import LazyLoad from "../../components/Common/LazyLoad";

const DashboardOrgAdmin = LazyLoad(() => import("./DashboardOrgAdmin"));
const SurveyList = LazyLoad(() => import("./Surveys/SurveyList/component"));
const EmployeeList = LazyLoad(() =>
  import("./UserManagement/EmployeeList/component")
);
const ControlLibrary = LazyLoad(() =>
  import("../Control_library/LinkList/ControlLibrary")
);
const OrganisationProfile = LazyLoad(() => import("./OrganisationProfile"));

const AdminLayout = () => {
  return (
    // Navigation now comes from the shared AppShell sidebar (see Authmiddleware),
    // so this area renders only its routed content.
    <div className="list-container fixed">
      <Switch>
        <Route exact path="/admin-dashboard" component={DashboardOrgAdmin} />
        <Route path="/admin-survey-list" component={SurveyList} />
        <Route
          path="/admin-organization-profile"
          component={OrganisationProfile}
        />
        <Route path="/user-management" component={EmployeeList} />
        <Route path="/control-library" component={ControlLibrary} />
      </Switch>
    </div>
  );
};

export default AdminLayout;
